var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"link":!!_vm.to,"to":_vm.to}},[(_vm.icon)?_c('v-list-item-action',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1):_vm._e(),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.title))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }